var texts = {
 en: {
  text: 'Drag or \n click to add.'
 },
 sp: {
  text: 'Arrastra ó \n da clic para añadir.'
 }
};

export default texts;